module.exports = __webpack_public_path__ + "c7a91481e8f05db181c99b15723aca22.MP3";